import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DanfeContext from '../../../../contexts/import/danfe/DanfeContext';
import {
  selectError,
  selectResponse,
  selectStatus,
} from '../../../../features/danfe/danfeSelectors';
import {
  clearError,
  clearResponse,
  resetStatus,
} from '../../../../features/danfe/danfeSlice';
import { setErrorFeedback, setSuccessFeedback } from '../../../../features/feedback/feedbackSlice';
import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';
import { isFailureStatus, isLoadingStatus, isSuccessStatus } from '../../../../utils/store/store-utils';

export default function DanfePage({ children }) {
  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const error = useSelector(selectError);
  const response = useSelector(selectResponse);

  const isLoading = useMemo(() => (
    isLoadingStatus(status)
  ), [status]);

  useEffect(() => {
    if (isFailureStatus(status) && error && error.message) {
      dispatch(setErrorFeedback({
        message: error.message,
      }));
      dispatch(resetStatus());
      dispatch(clearError());
    } else if (isSuccessStatus(status) && response && response.message) {
      dispatch(setSuccessFeedback({
        message: response.message,
      }));
      dispatch(resetStatus());
      dispatch(clearResponse());
    }
  }, [response, status, error]);

  const providerData = useMemo(() => ({
    status,
    isLoading,
  }), [
    status,
    isLoading,
  ]);

  return (
    <DanfeContext.Provider value={providerData}>
      <QCXPageTemplate contextComponent={DanfeContext}>
        {children}
      </QCXPageTemplate>
    </DanfeContext.Provider>
  );
}
